import React from "react";
import { useTranslation } from "locales";
import BaseButton from "components/BaseButton";
import BaseIcon from "components/BaseIcon";
import FullWidthPageBackground from "components/FullWidthPageBackground";
import useModalLinkPrinter from "../../../../../../hooks/useModalLinkPrinter";
import "./style.scss";

export default function BlockUniversityCTA() {
  const { t } = useTranslation();
  const { getLocation } = useModalLinkPrinter();

  return (
    <div className="block-university-cta">
      <FullWidthPageBackground className="block-university-cta__background" />
      <div className="block-university-cta__content d-flex __column __align-center">
        <h2 className="block-university-cta__title h2 mb-4 text-center">
          {t("Ready to strengthen your careers promise?")}
        </h2>
        <div className="block-university-cta__description subtitle-1 fw-semibold text-center mb-6">
          {t("Let's discuss what a Secure The Offer partnership could look like for your cohort")}
        </div>
        <BaseButton
          className="block-university-cta__btn body-1 fw-semibold pl-4 pr-3"
          to={getLocation("/contact-us")}
          large
          dark
        >
          {t("Book a discovery call")}
          <BaseIcon className="f-shrink-0 ml-2">chevron-right</BaseIcon>
        </BaseButton>
      </div>
    </div>
  );
}
